
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 14.4V3.6s-10.92 7.62-11.982 8.015C10.974 11.238 0 3.6 0 3.6v10.8c0 1.5.318 1.8 1.8 1.8h20.4c1.517 0 1.8-.263 1.8-1.8zm-.017-12.917C23.983.39 23.664 0 22.2 0H1.8C.294 0 0 .468 0 1.56l.018.168s10.841 7.464 12 7.872C13.242 9.126 24 1.56 24 1.56l-.017-.077z","fill":"#625A54"}})])
          )
        }
      }
    